/**
 * Pure filter decision of the Voyage home grid, shared by assets/voyage-overview.js
 * and the node tests (tests/voyage-filter.test.mjs).
 *
 * Item shape (one entry of the `voyage-fixtures-json` island):
 *   { id, type: 'travel' | 'collection', collection_only, categories: 'a,b',
 *     zones: 'Z1|Z2', members (collections only: handles of the visible travels) }
 *
 * Rules:
 * - No filter ("Tout" = no category and no zone) shows everything except the
 *   effective collection-only travels.
 * - With a category or zone filter, a travel is shown iff it matches, collection-only
 *   or not. A collection card is shown iff at least one of its visible member
 *   travels matches (category AND zone on that same member).
 * - Map view: collection cards are hidden (no location) and collection-only travels
 *   are shown like any travel (pins).
 */
(function (root) {
  function listHas(value, separator, wanted) {
    return (value || '').split(separator).includes(wanted);
  }

  function matchesFilter(item, state) {
    if (state.category !== 'all' && !listHas(item.categories, ',', state.category)) return false;
    if (state.zone !== 'all' && !listHas(item.zones, '|', state.zone)) return false;
    return true;
  }

  /**
   * @param {object} item dataset entry
   * @param {{category: string, zone: string, mapView?: boolean}} state
   * @param {Map<string, object>} [byId] dataset entries by id, to resolve collection members
   */
  function isCardVisible(item, state, byId) {
    const filterActive = state.category !== 'all' || state.zone !== 'all';

    if (item.type === 'collection') {
      if (state.mapView) return false;
      if (!filterActive) return true;
      return (item.members || []).some((id) => {
        const member = byId && byId.get(id);
        return member ? matchesFilter(member, state) : false;
      });
    }

    if (item.collection_only && !filterActive && !state.mapView) return false;
    return matchesFilter(item, state);
  }

  const api = { isCardVisible, matchesFilter };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.TbVoyageFilter = api;
})(typeof window !== 'undefined' ? window : globalThis);
